<template>
	<div class="topBar">
		<div class="topBar-title">
			<img @click="showHideHomeMenu" src="../../assets/common/icons/menu.png"
				:class="isShowHomeMenu?'rotateBackIcon':'rotateAroundIcon'" v-if="scheduleMode != 'userManage'" />
			<span>日程安排管理系统</span>
			<span v-if="scheduleMode == 'userManage'">—用户管理</span>
		</div>
		<div class="topBar-tools">
			<div class="topBar-modeSwitchBtn" @click="switchScheduleMode" v-if="scheduleMode != 'userManage'">
				<span v-if="scheduleMode == 'calendar'">切换为列表模式</span>
				<span v-if="scheduleMode == 'list'">切换为日历模式</span>
			</div>
			<div class="search-schedule-Btn" @click="showHideSearchBar" v-if="scheduleMode != 'userManage'">
				<img src="../../assets/common/icons/searchIcon.png" />
			</div>
			<div class="back-to-home-btn" @click="backToHomePage" v-if="scheduleMode == 'userManage'">
				<img src="../../assets/common/icons/backToHome.png" />
				<span>回到首页</span>
			</div>
			<div class="topBar-noticeIcon" v-if="scheduleMode != 'userManage'">
				<el-popover placement="bottom-end" width="600" trigger="click" :offset="240" ref="noticeList">
					<img v-if="scheduleMode == 'calendar'" src="../../assets/common/icons/noticeIcon.png"
						slot="reference" />
					<img @click="showNoticeList" v-if="scheduleMode == 'list'" slot="reference"
						src="../../assets/common/icons/haveNoticeIcon.png" />
					<noticeList></noticeList>
				</el-popover>
			</div>
			<el-popover placement="bottom" :width="userManageMenuPopoverWidth" trigger="click" ref="userManageMenu">
				<div class="topBar-userInfo" slot="reference">
					<img class="topBar-userInfo-headImg" v-if="loginUserInfo.headImg" :src="loginUserInfo.headImg" />
					<img class="topBar-userInfo-headImg" v-else src="../../assets/common/userHeadImg_Default.png" />
					<span>{{loginUserInfo.name}}</span>
					<img class="topBar-userInfo-pointDown" src="../../assets/common/icons/pointer_down.png" />
				</div>
				<div class="user-manage-menu">
					<div class="user-manage-menu-each userManage" @click="toUserManagePage"
						v-if="scheduleMode != 'userManage' && userId == 1">
						<img src="../../assets/common/icons/userManage.png" />
						<span>用户管理</span>
					</div>
					<div class="user-manage-menu-each" @click="logout">
						<img src="../../assets/common/icons/logOut.png" />
						<span>退出登录</span>
					</div>
				</div>
			</el-popover>
		</div>
	</div>
</template>

<script>
	import noticeList from './NoticeList.vue';
	export default {
		components: {
			noticeList
		},
		props: {
			scheduleMode: { //日程查看模式-日历、列表
				type: String,
				default: 'calendar'
			},
			userId: { //当前登录用户Id
				type: Number,
				default: -1
			}
		},
		data() {
			return {
				isShowHomeMenu: true, //是否展示首页左侧菜单栏
				loginUserInfo: {}, //登录用户信息
				userManageMenuPopoverWidth: 200, //用户菜单弹出框宽度
			}
		},
		mounted() {
			let that = this;
			that.$nextTick(() => {
				let mediaQuery1024 = window.matchMedia("(min-width: 1024px)");
				that.userManageMenuPopoverWidth = 150;
				if (mediaQuery1024.matches) {
					that.userManageMenuPopoverWidth = 150;
				}
				let mediaQuery1680 = window.matchMedia("(min-width: 1680px)");
				if (mediaQuery1680.matches) {
					that.userManageMenuPopoverWidth = 200;
				}
			})
		},
		watch: {
			userId: {
				handler(newUserId, oldUserId) {
					let that = this;
					if (newUserId != -1) {
						that.getLoginUserInfo();
					}
				},
				immediate: true,
				deep: true
			}
		},
		methods: {
			//点击获取当前登录用户信息
			getLoginUserInfo() {
				let that = this;
				let params = {
					userId: that.userId
				};
				that.$api.getUserInfo(params).then(res => {
					console.log(res)
					if (res.code == 1) {
						that.loginUserInfo = res.data;
						that.$bus.$emit("getLoginUserInfo", res.data);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//点击展示或隐藏首页左侧菜单栏
			showHideHomeMenu() {
				let that = this;
				that.isShowHomeMenu = !that.isShowHomeMenu;
				that.$emit("showHideHomeMenu", that.isShowHomeMenu);
			},
			//点击切换日程显示模式
			switchScheduleMode() {
				let that = this;
				that.$emit("switchScheduleMode");
			},
			//点击展示系统通知列表
			showNoticeList() {
				let that = this;
			},
			//点击显示隐藏搜索栏
			showHideSearchBar() {
				let that = this;
				that.$emit("showHideSearchBar");
			},
			//点击跳转到用户管理界面
			toUserManagePage() {
				let that = this;
				that.$refs['userManageMenu'].doClose();
				that.$router.replace("/userManage");
			},
			//点击退出登录
			logout() {
				let that = this;
				that.$refs['userManageMenu'].doClose();
				localStorage.removeItem("userInfo");
				that.$router.replace("/login");
			},
			//点击回到首页
			backToHomePage() {
				let that = this;
				that.$router.replace("/home");
			}
		}
	}
</script>

<style lang="scss">
	.topBar {
		background-color: #3F79F7;
		color: #fff;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;

		.topBar-title {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;

			img {
				cursor: pointer;
			}

			span {
				font-weight: 400;
			}

			.rotateBackIcon {
				// transition: all 0.5s;
			}

			.rotateAroundIcon {
				transform: rotateZ(-180deg);
				// transition: all 0.5s;
			}
		}

		.topBar-tools {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-end;

			.topBar-modeSwitchBtn {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: center;
				background-color: #04BD63;
				cursor: pointer;

				span {
					font-weight: bold;
				}
			}

			.search-schedule-Btn {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: center;
				cursor: pointer;

				img {}
			}

			.back-to-home-btn {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: center;
				cursor: pointer;
				background-color: #79A4FB;
				opacity: 0.85;

				img {}

				span {
					font-weight: 400;
					color: #fff;
				}
			}

			.topBar-noticeIcon {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: center;

				img {
					cursor: pointer;
				}
			}

			.topBar-userInfo {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: flex-end;
				cursor: pointer;

				span {
					font-weight: 400;
				}
			}
		}
	}

	.user-manage-menu {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: center;

		.user-manage-menu-each {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			width: 100%;
			box-sizing: border-box;
			cursor: pointer;

			img {}

			span {
				font-weight: 400;
				color: #333333;
			}
		}

		.user-manage-menu-each:last-child {
			span {
				color: #E2062A;
			}
		}
	}

	@media screen and (min-width: 1024px) {
		.topBar {
			height: 47px;
			padding: 0 16px;

			.topBar-title {
				span {
					font-size: 18px;
				}

				img {
					width: 34px;
					height: 34px;
					margin: 0 20px 0 0;
				}
			}

			.topBar-tools {
				.topBar-modeSwitchBtn {
					padding: 10px 20px;
					border-radius: 3px;

					span {
						font-size: 16px;
					}
				}

				.search-schedule-Btn {
					margin: 0 0 0 12px;

					img {
						width: 25px;
						height: 25px;
					}
				}

				.back-to-home-btn {
					border-radius: 3px;
					padding: 6px 10px;
					margin: 0 28px 0 0;

					img {
						width: 23px;
						height: 23px;
						margin: 0 11px 0 0;
					}

					span {
						font-size: 16px;
					}
				}

				.topBar-noticeIcon {
					margin: 0 20px 0 12px;

					img {
						width: 25px;
						height: 25px;
					}
				}

				.topBar-userInfo {
					.topBar-userInfo-headImg {
						width: 40px;
						height: 40px;
					}

					span {
						margin: 0 13px 0 15px;
						font-size: 16px;
					}

					.topBar-userInfo-pointDown {
						width: 12px;
						height: 12px;
					}
				}
			}
		}

		.user-manage-menu {
			.user-manage-menu-each {
				padding: 16px 0;

				img {
					width: 23px;
					height: 23px;
					margin: 0 12px 0 0;
				}

				span {
					font-size: 16px;
				}
			}

			.userManage {
				border-bottom: 1px solid #333;
			}
		}
	}

	@media screen and (min-width: 1280px) {}

	@media screen and (min-width: 1366px) {}

	@media screen and (min-width: 1440px) {}

	@media screen and (min-width: 1680px) {
		.topBar {
			height: 78px;
			padding: 0 30px;

			.topBar-title {
				span {
					font-size: 29px;
				}

				img {
					width: 56px;
					height: 56px;
					margin: 0 30px 0 0;
				}
			}

			.topBar-tools {
				.topBar-modeSwitchBtn {
					padding: 16px 32px;
					border-radius: 5px;

					span {
						font-size: 26px;
					}
				}

				.search-schedule-Btn {
					margin: 0 0 0 18px;

					img {
						width: 40px;
						height: 40px;
					}
				}

				.back-to-home-btn {
					border-radius: 5px;
					padding: 10px 18px;
					margin: 0 46px 0 0;

					img {
						width: 40px;
						height: 40px;
						margin: 0 18px 0 0;
					}

					span {
						font-size: 26px;
					}
				}

				.topBar-noticeIcon {
					margin: 0 36px 0 18px;

					img {
						width: 40px;
						height: 40px;
					}
				}

				.topBar-userInfo {
					.topBar-userInfo-headImg {
						width: 65px;
						height: 65px;
					}

					span {
						margin: 0 20px 0 24px;
						font-size: 26px;
					}

					.topBar-userInfo-pointDown {
						width: 20px;
						height: 20px;
					}
				}
			}
		}

		.user-manage-menu {
			.user-manage-menu-each {
				padding: 40px 10px;

				img {
					width: 40px;
					height: 40px;
					margin: 0 20px 0 0;
				}

				span {
					font-size: 26px;
				}
			}

			.userManage {
				border-bottom: 1px solid #333;
			}
		}
	}

	@media screen and (min-width: 1920px) {
		.topBar {
			height: 90px;
		}
	}
</style>